module.exports = __webpack_public_path__ + "public/img/bukalapak.50ebaf8b.png";